module.exports = __webpack_public_path__ + "static/NeueEinstellungMedium-e6bd1ccc2ec089df4ddfed3112216ef1.woff";